import { render, staticRenderFns } from "./CloseChatSession.vue?vue&type=template&id=b60f537a&scoped=true"
import script from "./CloseChatSession.vue?vue&type=script&lang=js"
export * from "./CloseChatSession.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b60f537a",
  null
  
)

export default component.exports